/**
 * First-touch attribution for signups, without cookies: when a visitor clicks
 * through to the app, the campaign they arrived with travels along in the
 * link's query (utm_*, plus the site, landing page and referring host). The
 * app keeps it with the organization that signs up. Nothing is stored on the
 * device, and nothing personal is added: these are campaign labels and hosts.
 */

/** The app's hosts that receive attribution: the app itself, not any outbound link. */
export function isAppHost(host: string): boolean {
  return /^app\.logpulse\.(io|nl|de|fr|es|it)$/.test(host) || host === 'localhost:5173';
}

export interface LandingContext {
  /** utm_* captured on the landing page. */
  utm: Record<string, string>;
  /** The marketing site, e.g. logpulse.nl. */
  site: string;
  /** Path of the first page of the visit. */
  landing: string;
  /** Host of the page that sent the visitor, or empty for direct. */
  referrerHost: string;
}

/** The app URL with the visit's attribution added; existing parameters win. */
export function decorateSignupUrl(url: URL, ctx: LandingContext): URL {
  const out = new URL(url.toString());
  const set = (key: string, value: string | undefined) => {
    if (value && !out.searchParams.has(key)) out.searchParams.set(key, value.slice(0, 120));
  };
  for (const [key, value] of Object.entries(ctx.utm)) set(key, value);
  set('lp_site', ctx.site);
  set('lp_landing', ctx.landing);
  if (ctx.referrerHost && ctx.referrerHost !== ctx.site) set('lp_ref', ctx.referrerHost);
  return out;
}
